import React from 'react';

import styles from './PlatformUsageGraph.module.scss';
import api from '../../../helpers/api';
import {$t} from '../../../helpers/translator';
import moment from 'moment';

import MultiSelect from '../../miscellaneous/MultiSelect/MultiSelect';
import TimePeriodSelector from '../../miscellaneous/TimePeriodSelector/TimePeriodSelector';
import Loader from '../../miscellaneous/Loader/Loader';
import _ from "lodash";
import {ResponsiveBar} from '@nivo/bar'


class PlatformUsageGraph extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,

            payload: {
                filter: 'area',
                startDate: moment().subtract(1, 'year'),
                endDate: moment(),
            },

            data: null,

            filterOptions: [
                {
                    label: $t('global.machines.area'),
                    value: 'area',
                },
                {
                    label: $t('global.machines.staff'),
                    value: 'staff',
                },
                {
                    label: $t('global.machines.month'),
                    value: 'month',
                },
                {
                    label: $t('global.machines.applicator'),
                    value: 'applicator',
                },
            ],
            selectedFilter: {
                label: $t('global.machines.area'),
                value: 'area',
            },

            dayMonthOptions: [
                {
                    label: $t('global.machines.daily'),
                    value: 'day',
                },
                {
                    label: $t('global.machines.monthly'),
                    value: 'month',
                },
            ],
            selectedDayMonth: {
                label: $t('global.machines.monthly'),
                value: 'month',
            },

        };
    }

    async componentDidMount() {
        this.fieldChangeHandler(this.state.filterOptions[0]);
        await this.init();
    }

    async init() {
        this.setState({loading: true}, async () => {
            try {
                // let res = await apy.getPlatformUsageData(this.props.platformId, this.state.payload);
                let payload = this.state.payload;
                payload.machineId = this.props.platformId

                let url = `/platform/${this.props.platformId}/quantity?startDate=${payload.startDate.format('YYYY-MM-DD')}
                &endDate=${payload.endDate.format('YYYY-MM-DD')}
                &filter=${payload.filter}`;
                let res = await api.get(url);

                if (res && res.success) {
                    this.setState({data: res.data.data}, () => {
                        // this.autoSelectDayOrMonth(res.data.data);

                        if (this.state.payload.filter === 'month' && this.state.selectedDayMonth.value === 'month') {
                            let data = this.daysToMonths(res.data.data);
                            this.renderUsage(data);
                        } else {
                            this.renderUsage(res.data.data);
                        }
                    });
                }
            } catch (e) {
                console.error('err getting single platform usage', e);
            } finally {
                this.setState({loading: false}, () => {
                        // console.log('done.', this.state)
                    }
                );
            }
        });
    }

    fieldChangeHandler(data) {
        // console.log('fff', data)
        let payload = {...this.state.payload};
        payload.filter = data.value;
        this.setState({
            payload: payload,
            selectedFilter: data
        }, async () => {
            await this.init()
            // console.log('stateselectedFilter', this.state.selectedFilter);
        });
    }

    datesChangeHandler(data) {
        let payload = {...this.state.payload};
        payload.startDate = data.startDate;
        payload.endDate = data.endDate;

        this.setState({payload: payload}, async () => await this.init());
    }

    dayMonthSelectedHandler(selection) {
        let data = this.state.data;

        if (selection.value === 'month') {
            data = this.daysToMonths(data);
        }

        this.setState({selectedDayMonth: this.state.dayMonthOptions[selection.key]}, () => {
            this.renderUsage(data);
        });
    }

    daysToMonths(data) {
        let newData = [];
        _.forEach(data, (v, k) => {
            let date = v.label.split('/');

            let i = _.findIndex(newData, function (o) {
                return o.label === date[1] + '/' + date[2];
            });
            if (i > -1) {
                newData[i].y += v.y;
            } else {
                newData.push({
                    label: date[1] + '/' + date[2],
                    y: v.y
                });
            }
        });
        return newData;
    }

    renderUsage(data) {
        // console.log('>>>>>', data)
        let newData = [];
        _.forEach(data, (v) => {
            // console.log(v);
            v.treatments_str = $t('global.machines.treatments');
            v.area_str = $t('global.treatments.area');
            v.id_str = $t('global.machines.id');
            v.serial_str = $t('global.machines.serialNumber');
            v.model_str = $t('global.machines.model');
            v.staff_str = $t('global.patients.staff');
            v.period_str = $t('global.machines.period');

            if (this.state.payload.filter === 'area') {
                v.name = v.label = $t('global.areas.' + v.label);
                v.toolTipContent = '<div><div>{area_str}: <b>{name}</b></div><div>{treatments_str}: <b>{y}</b></div><img src={image} width="100"></div>';
            }

            if (this.state.payload.filter === 'applicator') {
                let temp = v.label;
                v.model = v.name;
                v.label = v.serial_number ? v.serial_number : v.name;
                v.serial_number = v.serial_number ? v.serial_number : 'N/A';
                v.name = temp;

                v.toolTipContent = '<div><div>{model_str}: <b>{model}</b><div>{serial_str}: <b>{serial_number}</b><div>{id_str}: <b>{name}</b></div><div>{treatments_str}: <b>{y}</b></div><img src={image} width="100"></div>';
            }

            if (this.state.payload.filter === 'staff') {
                v.toolTipContent = '<div><div>{staff_str}: <b>{label}</b></div><div>{treatments_str}: <b>{y}</b></div></div>';
            }
            if (this.state.payload.filter === 'month') {
                v.toolTipContent = '<div><div>{period_str}: <b>{label}</b></div><div>{treatments_str}: <b>{y}</b></div></div>';
            }

            if (this.state.payload.filter === 'month' || (this.state.payload.filter !== 'month' && v.y !== 0)) {
                newData.push(v)
            }
        })
        // if (newData.length < 2) {
        //     newData = data;
        // }

        this.setState({data: newData}, () => {
            // console.log('>>>>', this.state.data);
        })
    }

    render() {
        return (
            <div className={`${styles['container']}`}>
                <div className={`${styles['filters-row']}`}>
                    <div>
                        <div className={`${styles['filter-name']}`}>{$t('global.machines.sortBy')}</div>
                        <div className={`${styles['select']}`}>
                            <MultiSelect
                                options={this.state.filterOptions}
                                selected={this.state.selectedFilter}
                                onValueChange={(data) => this.fieldChangeHandler(data)}
                            />
                        </div>
                    </div>
                    <div style={(this.state.payload.filter !== 'month' ? {display: 'none'} : {})}>
                        <div className={`${styles['filter-name']}`}>{$t('global.machines.selectTimePeriod')}:</div>
                        <TimePeriodSelector startDate={this.state.payload.startDate}
                                            endDate={this.state.payload.endDate}
                                            maxDate={moment()}
                            // length={1000}
                                            hideQuarters
                                            styles={{minHeight: '38px'}}
                                            onDatesChange={this.datesChangeHandler.bind(this)}/>
                    </div>
                    <div style={(this.state.payload.filter !== 'month' ? {display: 'none'} : {})}>
                        <div className={`${styles['filter-name']}`}>{$t('global.machines.period')}</div>
                        <div className={`${styles['select']}`}>
                            <MultiSelect
                                options={this.state.dayMonthOptions}
                                selected={this.state.selectedDayMonth}
                                onValueChange={(data) => this.dayMonthSelectedHandler(data)}
                            />
                        </div>
                    </div>
                </div>
                {this.state.loading ?
                    <div className={`${styles['loader-container']}`}>
                        <Loader/>
                    </div>
                    :
                    null
                }

                {this.state.data &&
                    <div className={styles.graphContainer}
                         style={{maxWidth: '100%', maxHeight: '100%'}}>
                        <ResponsiveBar
                            data={this.state.data}
                            keys={[
                                'y',
                            ]}
                            indexBy="label"
                            margin={{top: 50, right: 40, bottom: 50, left: 60}}
                            padding={0.3}
                            indexScale={{type: 'band', round: true}}
                            colors={{scheme: 'nivo'}}
                            borderColor={{
                                from: 'color',
                                modifiers: [
                                    [
                                        'darker',
                                        1.6
                                    ]
                                ]
                            }}
                            axisTop={null}
                            axisRight={null}
                            axisBottom={{
                                tickSize: 5,
                                tickPadding: 5,
                                tickRotation: 0,
                                legend: this.state.selectedFilter.label,
                                legendPosition: 'middle',
                                legendOffset: 32
                            }}
                            axisLeft={{
                                tickSize: 5,
                                tickPadding: 5,
                                tickRotation: 0,
                                legend: $t('global.machines.treatments'),
                                legendPosition: 'middle',
                                legendOffset: -40
                            }}
                            labelSkipWidth={12}
                            labelSkipHeight={12}
                            tooltip={(v) => {
                                return <div>{v.id_str}</div>;
                            }}
                        />
                    </div>
                }

            </div>
        );
    }

}

export default PlatformUsageGraph;
